module.exports = __webpack_public_path__ + "img/logo_blue.c67293de.png";